import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionTargetKind as r } from "../types/HostActionTarget.mjs";
import { HousekeepingAttentionKind as i } from "@maat/api-main/types";
//#region src/mappers/toHousekeepingActions.ts
var a = (e) => [e.room_name, e.property_name].filter(Boolean).join(" · ") || void 0, o = (o) => o.filter((e) => e.kind === i.RoomOutOfOrderWithBookings).map((i) => ({
	id: `${e.RoomOutOfOrderWithBookings}:${i.unit_id}`,
	type: e.RoomOutOfOrderWithBookings,
	intent: t.Blocker,
	params: { count: i.bookings_on_room },
	object: a(i),
	facets: [{
		kind: n.Count,
		count: i.bookings_on_room
	}],
	target: {
		kind: r.FrontDeskToday,
		id: i.property_id
	}
})), s = (n) => n.filter((e) => e.kind === i.ArrivalRoomNotReady).map((n) => ({
	id: `${e.ArrivalRoomNotReady}:${n.booking_id ?? n.unit_id}`,
	type: e.ArrivalRoomNotReady,
	intent: t.Blocker,
	params: n.hk_status ? { variant: n.hk_status } : void 0,
	object: a(n),
	target: {
		kind: r.FrontDeskToday,
		id: n.property_id
	}
}));
//#endregion
export { s as toArrivalRoomNotReadyActions, o as toRoomOutOfOrderActions };
